import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import HomeThreeSingleBlog from '../../../../components/HomeThreeSingleBlog/HomeThreeSingleMainBlog';
import { Link } from 'react-router-dom';
import { FaPlay, FaBookOpen, FaBalanceScale, FaWallet } from 'react-icons/fa';
import ModalVideo from 'react-modal-video';
import 'react-modal-video/scss/modal-video.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination } from 'swiper';
import "swiper/css/pagination";

SwiperCore.use([Navigation, Pagination]);

const HomeTwoAbout = () => {
   const [open, setOpen] = useState(false);   
   const setVid = () => {      
      setOpen(true)
   }
   return (
      <>
         {open && (
            <Modal show={open} style={{background: "transparent"}} >
               <ModalVideo channel='youtube' autoplay isOpen={open} videoId="PvHkXHTGQSo" onClose={() => setOpen(false)} />                 
          </Modal>
         )}

         <section className="tp-about-area-two fix pt-40 pb-40">
            <div className="container">
               <div className="row">
                                          
                     <div className="section-title-wrapper mb-20 col-12">
                        <h2 className="tp-section-title-two translate-y--10 text-center">Augmenting <span>MSMEs</span> Growth Journey</h2>
                     </div>

                  <div className="col-lg-5 col-md-10">
                     <div className="tp-about-img-two position-relative mr-80 wow fadeInUp" data-wow-delay=".4s">
                        <a target="_blank" href="https://www.neogrowth.in/msme-insight-report-2022/">
                           <img src="assets/img/about/book-cover-option-3.jpeg" className="img-fluid" alt="img not found" style={{boxShadow: "-11px 12px 14px 9px rgb(0 0 0 / 45%), 5px -2px 20px 10px rgb(0 0 0 / 6%)"}}/>
                        </a>
                        {/* <img src="assets/img/about/416.png" className="img-fluid img-second" alt="img not found"/> */}
                           {/* <div className="tp-about-img-two-badge">
                              <h3>9</h3>
                              <h5>years <br/>Experience</h5>
                           </div> */}
                     </div>
                     </div>
                     <div className="col-lg-7">                                       
                        
                        <div className="tp-about-text-two wow fadeInUp" data-wow-delay=".7s">
                           {/* <div className="section-title-wrapper mb-20">
                              <h2 className="tp-section-title-two translate-y--10">Augmenting <span>MSMEs</span> Growth Journey</h2>
                           </div> */}
                           {/* <p className="mb-40">Fusce fusce ante dis varius iaculis quis veile litora nascetur diam dapibus euismod neque sapien siverra nunc nisler fortune litora neque.</p> */}
                           
                           <div className="tp-about-text-two-service mt-4">
                              <a target="_blank" href="https://www.neogrowth.in/msme-insight-report-2022/">
                                 <div className="tp-about-text-two-service-single mb-4">
                                    <div className="tp-about-text-two-service-single-icon mb-10">
                                       <span><i ><FaBookOpen /></i></span>
                                    </div>
                                    <div className="tp-about-text-two-service-single-text">
                                       <h4 className="tp-about-text-two-service-title">MSME Insight Report 2022
                                          <p style={{color: "#89BA2B"}}>Rising In The Face Of Adversity</p>
                                          <p>Analysis of key trends observed by NeoGrowth in the MSME ecosystem during the COVID-19 disruption</p>
                                       </h4>
                                    </div>
                                 </div>
                              </a>
                           </div>

                           {/*<div style={{top:"0%", left:"0%",bottom:"0%",right:"0%", position:"relative" }}>
                           <div className="tp-about-text-two-service-single pt-4" >
                              <Link to="" onClick={() => setVid(true)} style={{cursor:"pointer"}} >
                                 <img src="assets/img/about/image-3.jpeg" className="img-fluid" alt="img not found" style={{boxShadow: "rgb(126 126 126 / 45%) -1px 1px 14px 5px, rgb(0 0 0 / 1%) 4px -2px 2px 1px", borderRadius: "10px", top:"0%", left:"0%",bottom:"0%",right:"0%" }}/>
                              </Link>                                                            
                           </div>

                              <div className="p-3" onClick={() => setVid(true)}  style={{background:"#ea1c1ced", position:"absolute", borderRadius:"10px", top:"50%", left:"45%",cursor:"pointer" }}>
                                 <i ><FaPlay /></i>
                              </div>
                           </div>*/}

                           {/* <div className=" p-3" style={{background:"#ea1c1ced", borderRadius:"10px" }}>                           
                                 <i ><FaPlay /></i>
                           </div> */}

                           

                              {/* <a target="_blank" href="https://www.linkedin.com/feed/update/urn:li:activity:6969987019443712000/?updateEntityUrn=urn%3Ali%3Afs_feedUpdate%3A%28V2%2Curn%3Ali%3Aactivity%3A6969987019443712000%29">
                              <div className="tp-about-text-two-service-single mb-60">
                                 <div className="tp-about-text-two-service-single-icon mb-10">
                                    <span><i> <FaBalanceScale /></i></span>
                                 </div>
                                 <div className="tp-about-text-two-service-single-text">
                                    <h4 className="tp-about-text-two-service-title">Account Aggregator
                                    <p style={{color: "#89BA2B"}}>Framework</p>
                                    <p>Integration of the framework in the digital loan journey, to strengthen & simplify digital lending for MSME borrowers</p>
                                    </h4>
                                 </div>
                              </div>
                              </a>
                              
                              <div className="tp-about-text-two-service-single mb-60" onClick={() => setVid(true)} style={{cursor:"pointer"}}>
                                    <div className="tp-about-text-two-service-single-icon mb-10">
                                       <span><i><FaWallet/></i></span>
                                    </div>                                 
                                 <div className="tp-about-text-two-service-single-text">
                                    <h4 className="tp-about-text-two-service-title">Accelerator
                                       <p style={{color: "#89BA2B"}}>Business Loan</p>
                                       <p>Simplifying the fund acquisition for Supply-Chain merchants</p>
                                       </h4>                                       
                                 </div>
                              </div> */} 
                              <Swiper
                        spaceBetween={30}
                        slidesPerView={1}
                        style={{ paddingBottom: '10px' }}
                        className='swiper-wrapper'
                        pagination={{ clickable: true }}
                        pauseOnMouseEnter= "true"
                        autoplay={{ delay: 6000 }}
                        breakpoints={{
                           550: {
                              slidesPerView: 1,
                           },
                           768: {
                              slidesPerView: 1,
                           },
                           992: {
                              slidesPerView: 1,
                           },
                           1024: {
                              slidesPerView: 1,
                           },
                           1200: {
                              slidesPerView: 1,
                           },
                        }}
                        navigation={{ nextEl: '.service-button-next', prevEl: '.service-button-prev', }}
                        // onSlideChange={() => console.log('slide change')}
                        // onSwiper={(swiper) => console.log(swiper)}
                     >
                        <SwiperSlide>
                           <HomeThreeSingleBlog image_num="100" linkk="https://youtu.be/PvHkXHTGQSo" vIds="PvHkXHTGQSo" />                           
                        </SwiperSlide>
                     </Swiper>
                                                     
                           
                        </div>
                     </div>
                  </div>
               </div>
         </section>
      </>
   );
};

export default HomeTwoAbout;